<template lang="pug">
  .form-group
    label {{ label }}
    MetadataDatePicker(v-model="localData" :error="!isValidInput() && !isValidDate(localData)" :placeholder="!isValidInput() ? requiredLabel : ''" :timePicker="true" :label="label" :disabled="disabled" @input="$emit('update:data', localData, isValidInput())")
</template>
<script>
import MetadataDatePicker from '../MetadataDatePicker'
import Base from '../base'

export default {
  extends: Base,
  accepts(property) {
    return property.type === 'string' && property.format === 'date-time'
  },
  components: {
    MetadataDatePicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/DateTime.vue